import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2868cf2c")

_pushScopeId("data-v-2868cf2c")
const _hoisted_1 = {
  key: 0,
  class: "select-wallet"
}
const _hoisted_2 = {
  key: 1,
  class: "wallet-info"
}
const _hoisted_3 = { class: "first" }
const _hoisted_4 = { class: "second" }
const _hoisted_5 = { class: "third" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = {
  key: 0,
  class: "select-wallet"
}
const _hoisted_8 = {
  key: 1,
  class: "wallet-info-app"
}
const _hoisted_9 = { class: "first" }
const _hoisted_10 = { class: "second" }
const _hoisted_11 = { class: "third" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_q_space = _resolveComponent("q-space")
  const _component_q_btn = _resolveComponent("q-btn")
  const _component_q_card_section = _resolveComponent("q-card-section")
  const _component_q_card = _resolveComponent("q-card")
  const _component_q_dialog = _resolveComponent("q-dialog")
  const _directive_close_popup = _resolveDirective("close-popup")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.rewardDialogVisible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.rewardDialogVisible = $event)),
      class: "gt-sm"
    }, {
      default: _withId(() => [
        _createVNode(_component_q_card, { class: "reward" }, {
          default: _withId(() => [
            _createVNode(_component_q_card_section, { class: "row items-center rewardTitle" }, {
              default: _withId(() => [
                _createVNode("div", null, _toDisplayString(_ctx.t('reward.larixBalance')), 1),
                _createVNode(_component_q_space),
                _withDirectives(_createVNode(_component_q_btn, {
                  icon: "close",
                  flat: "",
                  round: ""
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, { class: "rewardBody" }, {
              default: _withId(() => [
                (!_ctx.walletAddress)
                  ? (_openBlock(), _createBlock("div", _hoisted_1, [
                      _createVNode("div", null, _toDisplayString(_ctx.t('wallet.connectToAWallet')), 1)
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_2, [
                      _createVNode("div", null, [
                        _createVNode("img", {
                          src: _ctx.larixImg,
                          width: "86.4",
                          height: "86.4",
                          style: {"border-radius":"50%"}
                        }, null, 8, ["src"])
                      ]),
                      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.formatBigNumberStr(_ctx.$store.state.market.userLarixReward,2)), 1),
                      _createVNode("div", _hoisted_4, "$" + _toDisplayString(_ctx.formatBigNumberStr(_ctx.$store.state.market.userLarixReward.times(_ctx.larixPrice),2)), 1),
                      _createVNode("div", _hoisted_5, [
                        _createVNode("div", null, [
                          _createVNode("div", null, _toDisplayString(_ctx.t('wallet.walletBalance')), 1),
                          _createVNode("div", null, _toDisplayString(_ctx.formatBigNumberStr(_ctx.walletLarixBalance,2)), 1)
                        ]),
                        _createVNode("div", null, [
                          _createVNode("div", null, _toDisplayString(_ctx.t('wallet.unclaimedBalance')), 1),
                          _createVNode("div", null, _toDisplayString(_ctx.formatBigNumberStr(_ctx.$store.state.market.userLarixReward,6)), 1)
                        ]),
                        _createVNode("div", null, [
                          _createVNode("div", null, _toDisplayString(_ctx.t('wallet.price')), 1),
                          _createVNode("div", null, "$" + _toDisplayString(_ctx.larixPrice.toFixed(4,1)), 1)
                        ])
                      ]),
                      (_ctx.$store.state.market.userLarixReward.isGreaterThan(0))
                        ? (_openBlock(), _createBlock(_component_q_btn, {
                            key: 0,
                            round: "",
                            "no-caps": "",
                            class: "button",
                            onClick: _ctx.claimReward
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('wallet.harvest')), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : (_openBlock(), _createBlock(_component_q_btn, {
                            key: 1,
                            rounded: "",
                            "no-caps": "",
                            disabled: "",
                            class: "buttonDisabled",
                            onClick: _ctx.claimReward
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('wallet.nothingToClaim')), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                    ]))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.rewardDialogVisible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.rewardDialogVisible = $event)),
      class: "lt-md"
    }, {
      default: _withId(() => [
        _createVNode(_component_q_card, { class: "rewardApp" }, {
          default: _withId(() => [
            _createVNode(_component_q_card_section, { class: "row items-center rewardTitleApp" }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_6, _toDisplayString(_ctx.t('reward.larixBalance')), 1),
                _createVNode(_component_q_space),
                _withDirectives(_createVNode(_component_q_btn, {
                  icon: "close",
                  flat: "",
                  round: ""
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, { class: "rewardBodyApp" }, {
              default: _withId(() => [
                (!_ctx.walletAddress)
                  ? (_openBlock(), _createBlock("div", _hoisted_7, [
                      _createVNode("div", null, _toDisplayString(_ctx.t('wallet.connectToAWallet')), 1)
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_8, [
                      _createVNode("div", null, [
                        _createVNode("img", {
                          src: _ctx.larixImg,
                          width: "54",
                          height: "54",
                          style: {"border-radius":"50%"}
                        }, null, 8, ["src"])
                      ]),
                      _createVNode("div", _hoisted_9, _toDisplayString(_ctx.formatBigNumberStr(_ctx.$store.state.market.userLarixReward,6)), 1),
                      _createVNode("div", _hoisted_10, "$" + _toDisplayString(_ctx.formatBigNumberStr((_ctx.$store.state.market.userLarixReward.times(_ctx.larixPrice)),2)), 1),
                      _createVNode("div", _hoisted_11, [
                        _createVNode("div", null, [
                          _createVNode("div", null, _toDisplayString(_ctx.t('wallet.walletBalance')), 1),
                          _createVNode("div", null, _toDisplayString(_ctx.formatBigNumberStr(_ctx.walletLarixBalance,2)), 1)
                        ]),
                        _createVNode("div", null, [
                          _createVNode("div", null, _toDisplayString(_ctx.t('wallet.unclaimedBalance')), 1),
                          _createVNode("div", null, _toDisplayString(_ctx.formatBigNumberStr(_ctx.$store.state.market.userLarixReward,6)), 1)
                        ]),
                        _createVNode("div", null, [
                          _createVNode("div", null, _toDisplayString(_ctx.t('wallet.price')), 1),
                          _createVNode("div", null, "$$" + _toDisplayString(_ctx.larixPrice.toFixed(4,1)), 1)
                        ])
                      ]),
                      (_ctx.$store.state.market.userLarixReward.isGreaterThan(0))
                        ? (_openBlock(), _createBlock(_component_q_btn, {
                            key: 0,
                            round: "",
                            "no-caps": "",
                            class: "button",
                            onClick: _ctx.claimReward
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('wallet.harvest')), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : (_openBlock(), _createBlock(_component_q_btn, {
                            key: 1,
                            rounded: "",
                            "no-caps": "",
                            disabled: "",
                            class: "buttonDisabled",
                            onClick: _ctx.claimReward
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('wallet.nothingToClaim')), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                    ]))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
})